import createHeadingVariants from './createHeadingVariant'

/** @component */
export default createHeadingVariants(2)
